
export default class BaseFilter{
    constructor(options) {
        this._fieldName = options.fieldName;
    }
    show() {
        this.el.addClass('active');
    }
    hide() {
        this.el.removeClass('active');        
    }
    get name() {
        return this._fieldName;
    }
    apply() {        
        this.el.closest('form').submit();
    }    
    setupCloseApplyButtons() {        
        this.el.find('.filters__dropdown__close').click(this.hide.bind(this));
        this.el.find('.filters__dropdown__apply').click(this.apply.bind(this));

    }

}